export default __webpack_public_path__ + "static/softdrink-78879809b5084f800d02e0641e169e98.png";